import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { CabinetProvider } from "../context/CabinetContext";
import CabinetLayout from "../components/cabinet/CabinetLayout";
import WalletScreen from "../components/cabinet/screens/WalletScreen";
import usePageTitle from "../hooks/usePageTitle";

const TABS = [
  { id: "feed", label: "Главная", icon: "home" },
  { id: "top", label: "Топ", icon: "trophy" },
  { id: "avatar", label: "Аватар", icon: "userCircle" },
  { id: "friends", label: "Друзья", icon: "users" },
  { id: "more", label: "Ещё", icon: "more" },
];

/**
 * WalletPage — отдельная страница кошелька /app/wallet (2026-07-09).
 * Раньше кошелёк открывался модалкой (WalletModal) — по фидбэку МИНа
 * стал полноценной страницей кабинета. Контент — WalletScreen.
 */
function WalletInner() {
  usePageTitle("Кошелёк");
  const navigate = useNavigate();
  const { isAuthenticated, initializing } = useAuth();

  /* гостей — на логин с возвратом сюда */
  useEffect(() => {
    if (initializing) return;
    if (!isAuthenticated) {
      navigate("/login?next=/app/wallet", { replace: true });
    }
  }, [initializing, isAuthenticated, navigate]);

  return (
    <CabinetLayout
      tabs={TABS}
      activeTab=""
      onTabChange={(id) => navigate(`/app${id === "feed" ? "" : "?tab=" + id}`)}
      skinAvatar=""
    >
      <WalletScreen />
    </CabinetLayout>
  );
}

export default function WalletPage() {
  return (
    <CabinetProvider>
      <WalletInner />
    </CabinetProvider>
  );
}
